import { useQuery } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export type PaymentOptions = {
  countryCode: string | null;
  displayCurrencyCode: string;
  displayRate: number;
  countryNotProvided: boolean;

  card: {
    available: boolean;
    currencyCode: string;
  };

  mobilePayment: {
    available: boolean;
    providerCountryCode: string | null;
    currencyCode: string | null;
  };
};

const getPaymentOptions = async (): Promise<PaymentOptions> => {
  const response = await axios.get<PaymentOptions>("/payments/options");

  return response.data;
};

export const usePaymentOptions = (enabled = true) => {
  const query = useQuery({
    queryKey: ["payment-options"],
    queryFn: getPaymentOptions,
    enabled,
    staleTime: 60_000,
    refetchOnReconnect: true,
  });

  return {
    options: query.data,
    error: query.error,
    loading: query.isPending || (query.isFetching && !query.data),
    refreshing: query.isFetching,
    refetch: query.refetch,
  };
};
